export const contacts = {
list: {
  count_other: "{{count}} Kontakte",
  count_one: "{{count}} Kontakt",
  csv: {
    scope: "Sichtbar für",
    organisation: "Organisation",
    phone: "Telefon",
    email: "E-Mail",
    roles: "Rollen",
    displayName: "Anzeigename",
  },
  insight: {
    signalOrgs_other: "Bei {{count}} Organisationen fehlen Angaben.",
    signalOrgs_one: "Bei {{count}} Organisation fehlen Angaben.",
    signalSkills_other: "{{count}} Auftragnehmer haben keine Fähigkeiten erfasst.",
    signalSkills_one: "{{count}} Auftragnehmer hat keine Fähigkeiten erfasst.",
    signalVisible_other: "{{count}} Kontakte passen zu dieser Ansicht.",
    signalVisible_one: "{{count}} Kontakt passt zu dieser Ansicht.",
    summaryMissing_other: "{{count}} Kontakte haben weder E-Mail noch Telefonnummer.",
    summaryMissing_one: "{{count}} Kontakt hat weder E-Mail noch Telefonnummer.",
    source: "die Kontakte, die Sie sehen können",
    metricSkillGaps: "Ohne Fähigkeiten",
    metricMissingReach: "Ohne E-Mail/Telefon",
    metricVisible: "Angezeigt",
    signalOrgsOk: "Bei keiner Organisation fehlen Angaben.",
    signalSkillsOk: "Die angezeigten Auftragnehmer haben Fähigkeiten erfasst.",
    summaryOk: "Alle angezeigten Kontakte haben eine E-Mail-Adresse oder Telefonnummer.",
    actionOrgs: "Vervollständigen Sie Organisationsdaten vor Export oder Berichten.",
    actionSkills: "Erfassen Sie die Fähigkeiten von Auftragnehmern, damit für jeden Auftrag der passendste vorgeschlagen wird.",
    actionReach: "Hinterlegen Sie eine E-Mail-Adresse oder Telefonnummer bei Kontakten, denen Sie Arbeit geben.",
  },
  historySummary: "Zugehörige Arbeit, Notizen und Verzeichnislinks",
  untitledJob: "Auftrag ohne Titel",
  noLinkedSkills: "Noch keine Fähigkeiten",
  noRolesAssigned: "Noch keine Rollen",
  independentContact: "Unabhängiger Kontakt",
  kindInternal: "Intern",
  noSkillMatches: "Keine Fähigkeit gefunden.",
  searchSkills: "Fähigkeiten suchen…",
  showingA11y: "Angezeigt: {{role}}. Filter ändern",
  roleAll: "Alle",
  noContacts: "Keine Kontakte",
  purpose: "Externe Personen: Auftragnehmer, Lieferanten und Kunden",
  showMeHow: "Zeigen Sie mir, wie",
  clearFilters: "Filter zurücksetzen",
  addContractor: "Auftragnehmer hinzufügen",
title: "Kontakte",
addContact: "Kontakt hinzufügen",
loading: "Wird geladen…",
emptyFilteredTitle: "Keine passenden Kontakte",
loadFailedTitle: "Ihre Kontakte konnten nicht geladen werden",
loadUnavailableTitle: "Kontakte sind nicht verfügbar",
emptyTitle: "Noch keine Kontakte",
emptyFilteredSubtitle: "Nichts passt zu diesen Filtern. Tippen Sie auf Filter zurücksetzen, um alle zu sehen.",
emptyContractorsTitle: "Noch keine Auftragnehmer",
emptyContractorsSubtitle: "Fügen Sie einen Auftragnehmer hinzu, um ihm Aufträge zu geben oder Angebote anzufragen.",
visibilityGroupA11y: "Wer sie sehen kann",
visibilityChip: {
  all: "Alle",
  team: "Nur Team",
  account: "Ganzer Arbeitsbereich",
},
emptySubtitle: "Fügen Sie die Personen und Firmen hinzu, mit denen Sie arbeiten. Hinzugefügten Auftragnehmern können Sie Aufträge geben und Angebote anfragen.",
importLabel: "Importieren",
},
shared: {
kindLabel: "Kontakttyp",
kind: {
person: "Person",
organisation: "Organisation",
},
visibility: {
team: "Nur mein Team",
account: "Alle in meinem Unternehmen",
},
role: {
contractor: "Auftragnehmer",
landlord: "Vermieter",
owner: "Eigentümer",
client: "Kunde",
agent_broker: "Vertreter / Makler",
tenant: "Mieter",
supplier: "Lieferant",
inspector: "Prüfer",
occupant: "Nutzer",
driver: "Fahrer",
fleet_manager: "Flottenmanager",
operator: "Betreiber",
engineer: "Ingenieur",
technician: "Techniker",
other: "Sonstige",
},
roleGroup: {
general: "Allgemein",
property: "Immobilie",
fleet: "Flotte",
equipment: "Ausrüstung",
},
roleDescription: {
contractor: "Kann Arbeit, Angebotsanfragen und Auftragsaktualisierungen erhalten.",
landlord: "Vertritt den Immobilieneigentümer oder die Eigentümergruppe.",
owner: "Besitzt die Anlage oder das Portfolio, mit dem dieser Kontakt verknüpft ist.",
client: "Fordert Arbeit an, prüft Feststellungen oder genehmigt Reparaturen.",
agent_broker: "Handelt im Auftrag des Eigentümers, Kunden oder Mieters.",
tenant: "Nutzt oder bewohnt die Anlage und kann Probleme melden.",
supplier: "Liefert Materialien, Teile oder Fachdienstleistungen.",
inspector: "Führt Prüfungen, Begutachtungen oder Konformitätskontrollen durch.",
occupant: "Bewohnt, nutzt die Anlage oder ist ihr zugewiesen.",
driver: "Fährt oder ist einem Fahrzeug der Flotte zugewiesen.",
fleet_manager: "Verwaltet Fahrzeuge, Fahrer und den Flottenbetrieb.",
operator: "Bedient oder ist einem Ausrüstungsteil zugewiesen.",
engineer: "Wartet, überprüft oder repariert Ausrüstung.",
technician: "Führt praktische Wartung, Prüfung oder Reparatur von Ausrüstung durch.",
other: "Verwenden, wenn keine andere Rolle passt.",
},
primaryToggle: {
primary: "Primär",
makePrimary: "Als primär festlegen",
},
phoneType: {
mobile: "Mobil",
work: "Geschäftlich",
home: "Privat",
other: "Sonstige",
},
},
create: {
  contractorEmailHint: "Auftragnehmer brauchen eine E-Mail-Adresse: Aufträge und Angebotsanfragen werden dorthin gesendet.",
  headerSubtitleContractor: "Jemand außerhalb Ihres Teams, dem Sie Aufträge geben oder bei dem Sie Angebote anfragen können.",
  headerTitleContractor: "Neuer Auftragnehmer",
  visibilityEveryone: "Alle in Ihrem Unternehmen können diesen Kontakt sehen.",
headerTitle: "Neuer Kontakt",
headerSubtitle: "Fügen Sie eine Person oder Organisation zu Ihrem Kontoverzeichnis hinzu.",
unnamedFallback: "Unbenannter Kontakt",
roleSummary: "{{role}} - {{description}}",
a11y: {
person: "Kontakt ist eine Person",
organisation: "Kontakt ist eine Organisation",
},
alerts: {
  contractorEmailRequired: "Fügen Sie die E-Mail-Adresse hinzu, damit Aufträge und Angebotsanfragen ankommen.",
  contractorEmailTitle: "E-Mail-Adresse hinzufügen",
  createFailedTitle: "Kontakt konnte nicht hinzugefügt werden",
required: "Geben Sie einen Namen, eine E-Mail-Adresse oder eine Telefonnummer ein.",
noAccountTitle: "Konto nicht verfügbar",
noAccountBody: "Treten Sie einem Konto bei oder erstellen Sie eines, bevor Sie Kontakte hinzufügen.",
createFailed: "Dieser Kontakt konnte nicht hinzugefügt werden. Versuchen Sie es gleich noch einmal.",
emailNeededTitle: "E-Mail zum Teilen erforderlich",
emailNeededBody: "Fügen Sie eine gültige E-Mail-Adresse hinzu – darüber erhält dieser Kontakt die geteilte Anlage.",
invalidPhoneTitle: "Telefonnummer prüfen",
invalidPhoneBody: "Geben Sie eine gültige Nummer für das gewählte Land ein oder lassen Sie das Feld leer.",
},
sections: {
basicIdentityTitle: "Grundlegende Angaben",
basicIdentityHelper: "Wer dieser Kontakt ist und wie er in Ihrem Verzeichnis erscheinen soll.",
contactInfoTitle: "Kontaktinformationen",
contactInfoHelper: "Wie Ihr Team diese Person erreichen kann.",
whoIsThisTitle: "Wer ist das?",
whoIsThisHelper: "Wählen Sie, ob Sie eine Person oder eine Organisation hinzufügen.",
contactMethodTitle: "Wie erreichen wir diese Person?",
contactMethodHelper: "Fügen Sie die beste E-Mail-Adresse und Telefonnummer für die Rückmeldung hinzu.",
rolesWideTitle: "Rollen und Typen",
rolesWideHelper: "Wählen Sie alle Rollen aus, die für diesen Kontakt gelten sollen.",
visibilityWideTitle: "Sichtbarkeit",
visibilityWideHelper: "Wählen Sie, wer diesen Kontakt sehen und verwenden kann.",
rolesTitle: "Rollen",
rolesHelper: "Wählen Sie alle Rollen aus, die für diesen Kontakt gelten sollen.",
visibilityTitle: "Sichtbarkeit",
visibilityHelper: "Wählen Sie, wer diesen Kontakt sehen und verwenden kann.",
detailsWideTitle: "Weitere Angaben",
skillsTitle: "Fähigkeiten",
skillsHelper: "Fähigkeiten bestimmen, welchen Aufträgen dieser Kontakt zugewiesen werden kann und wer dafür vorgeschlagen wird.",
detailsTitle: "Weitere Angaben",
detailsHelper: "Optionale geschäftliche Angaben.",
},
labels: {
displayName: "Anzeigename",
organisation: "Name der Organisation",
organisations: "Organisationen",
company: "Unternehmen",
email: "E-Mail",
phone: "Telefon",
companyRegistrationNumber: "Handelsregisternummer",
vatTaxNumber: "USt-IdNr. / Steuernummer",
notes: "Notizen",
skills: "Fähigkeiten",
},
placeholders: {
displayName: "z. B. Alex Prüfer",
organisation: "z. B. Northside Property Group",
company: "z. B. Northside Services",
companyShort: "Optionaler Firmenname",
email: "name@example.com",
phone: "Beste Erreichbarkeit (Telefonnummer)",
companyRegistrationNumber: "Registernummer (optional)",
vatTaxNumber: "USt-IdNr. oder Steuernummer (optional)",
notes: "Private Notizen",
},
visibility: {
team: "Nur mein Team",
account: "Alle in meinem Unternehmen",
},
skillsPicker: {
title: "Fähigkeiten des Kontakts",
hint: "Wählen Sie Fähigkeiten aus Ihrem Kontokatalog. Sie erscheinen beim Kontakt und in Filtern.",
},
actions: {
saving: "Wird gespeichert...",
submit: "Kontakt hinzufügen",
submitContractor: "Auftragnehmer hinzufügen",
dictate: "Diktieren",
stopDictation: "Stopp",
},
title: "Kontakt hinzufügen",
addedAs: "Hinzugefügt als",
nameLabel: "Name",
namePlaceholder: "Vollständiger Name",
emailLabel: "E-Mail",
saveAndUse: "Kontakt hinzufügen und verwenden",
quickCreate: {
  duplicateReason: {
    name: "Gleicher Name",
    phone: "Gleiche Telefonnummer",
    email: "Gleiche E-Mail-Adresse",
  },
closeA11y: "Kontakt hinzufügen schließen",
requiredToShareSuffix: " · zum Teilen erforderlich",
reviewPossibleMatch: "Überprüfen Sie die mögliche Übereinstimmung",
discardTitle: "Diesen Kontakt verwerfen?",
discardBody: "Sie haben Kontaktdaten eingegeben, die noch nicht gespeichert wurden.",
keepEditing: "Bearbeiten Sie weiter",
discard: "Verwerfen",
duplicateHeading: "Möglicher bestehender Kontakt",
duplicateHint: "Wiederverwendung einer vorhandenen Identität, wenn es sich um dieselbe Person handelt. Beim Erstellen eines separaten Datensatzes werden Daten niemals automatisch zusammengeführt.",
useExisting: "Vorhandenes verwenden",
useExistingA11y: "Vorhandenen Kontakt {{name}} verwenden",
createSeparate: "Erstellen Sie einen separaten Kontakt",
createSeparateA11y: "Nach Prüfung auf Duplikate einen separaten Kontakt erstellen",
},
},
card: {
noDetails: "Keine Kontaktdaten",
invitedNotJoined: "Eingeladen · noch nicht beigetreten",
email: "E-Mail",
call: "Anrufen",
emailA11y: "E-Mail an {{name}}",
callA11y: "{{name}} anrufen",
roles: "Rollen",
skills: "Fähigkeiten",
none: "Keine",
unlink: "Verknüpfung mit {{name}} aufheben",
accessChange: "Zugriff: {{label}}. Ändern",
access: {
requester: "Darf anfragen",
viewer: "Darf ansehen",
none: "Kein Zugriff",
},
},
shareEdit: {
sendInvite: "Einladung senden",
resendInvite: "Einladung erneut senden",
sending: "Wird gesendet…",
removeAccess: "Zugriff entfernen",
},
detail: {
  inviterFallback: "Jemand, mit dem Sie zusammenarbeiten",
  noRolesYet: "Noch keine Rolle. Tippen Sie auf Bearbeiten und wählen Sie Auftragnehmer, um Aufträge zu vergeben.",
  inviteNeedsEmail: "Fügen Sie eine E-Mail-Adresse hinzu, um {{name}} einzuladen.",
  resendFailed: "Einladung konnte nicht erneut gesendet werden. Versuchen Sie es gleich noch einmal.",
title: "Kontakt",
loadingMessage: "Kontaktdaten werden geladen...",
noContactSelected: "Kein Kontakt ausgewählt",
contactNotFound: "Kontakt nicht gefunden",
loadFailedTitle: "Dieser Kontakt konnte nicht geladen werden",
loadUnavailableTitle: "Dieser Kontakt kann nicht angezeigt werden",
goBack: "Zurück",
scopeTeamOnly: "Nur mein Team",
sectionOverview: "Übersicht",
sectionRoles: "Rollen",
sectionContactDetails: "Kontaktdaten",
sectionInvitations: "Einladungen und Zugang",
sectionVisibility: "Sichtbarkeit",
sectionTeamAccess: "Teamzugriff",
sectionSkills: "Fähigkeiten",
sectionHistory: "Verlauf",
labelType: "Typ",
labelName: "Name",
labelOrganisation: "Organisation",
labelCompany: "Unternehmen",
labelCompanyRegistrationNumber: "Handelsregisternummer",
labelVatTaxNumber: "USt-IdNr. / Steuernummer",
labelStatus: "Status",
labelEmail: "E-Mail",
labelPhone: "Telefon",
labelAudience: "Sichtbar für",
labelOwningTeam: "Besitzerteam",
statusArchived: "Archiviert",
statusActive: "Aktiv",
noEmailOrPhone: "Keine E-Mail oder Telefon",
visibleToAllTeams: "Alle in Ihrem Unternehmen können diesen Kontakt sehen.",
noSkillsAssigned: "Keine Fähigkeiten zugewiesen. Bearbeiten Sie den Kontakt, um Tags aus Ihrem Kompetenzkatalog hinzuzufügen.",
joinedApp: "Dieser Kontakt ist der App beigetreten",
pendingInvites: "Ausstehende Einladung(en) – sie können sich über den Link anmelden",
noInvitesYet: "Noch keine Einladungen",
inviteSent: "Gesendet {{date}}",
inviteExpires: "Läuft {{date}} ab",
inviteStatus: {
pending: "ausstehend",
accepted: "akzeptiert",
revoked: "widerrufen",
expired: "abgelaufen",
},
resend: "Erneut senden",
revoke: "Entziehen",
revokeInviteTitle: "Einladung widerrufen",
revokeInviteMessage: "Dadurch wird die Einladung abgebrochen.",
cancel: "Abbrechen",
edit: "Bearbeiten",
editContactA11y: "Kontakt bearbeiten",
contactAlreadyInApp: "Kontakt bereits in App",
inviteContactToAppA11y: "Kontakt zur App einladen",
alreadyInApp: "Bereits in App",
inviteToApp: "Zur App einladen",
invite: "Einladen",
share: "Teilen",
shareWithTeam: "Mit dem Team teilen",
shareContactWithTeamA11y: "Kontakt mit dem Team teilen",
shareContactWithAnotherTeamA11y: "Teilen Sie den Kontakt mit einem anderen Team",
promote: "Mit allen Teams teilen",
promoteToAccount: "Mit allen Teams teilen",
promoteContactToAccountA11y: "Diesen Kontakt mit allen Teams teilen",
promoteContactVisibilityA11y: "Diesen Kontakt mit allen Teams teilen",
archiveContact: "Kontakt archivieren",
archive: "Archivieren",
backToContactsListA11y: "Zurück zur Kontaktliste",
contactsBreadcrumb: "Kontakte",
noOtherTeamsTitle: "Keine anderen Teams",
noOtherTeamsBody: "Es gibt keine anderen Teams, mit denen dieser Kontakt geteilt werden kann.",
sharedTitle: "Geteilt",
sharedBody: "Kontakt geteilt mit {{team}}.",
fallbackTeam: "Team",
errorTitle: "Das hat nicht geklappt",
failedToShare: "Kontakt konnte nicht geteilt werden. Versuchen Sie es gleich noch einmal.",
promoteToAccountBody: "Alle in Ihrem Unternehmen werden diesen Kontakt sehen können.",
doneTitle: "Fertig",
promotedBody: "Alle in Ihrem Unternehmen können diesen Kontakt jetzt sehen.",
failedToPromote: "Kontakt konnte nicht mit allen Teams geteilt werden. Versuchen Sie es gleich noch einmal.",
invitationSentTitle: "Einladung gesendet",
invitationSentBody: "Eine E-Mail wurde an {{email}} gesendet.",
invitationCreatedTitle: "Einladung gespeichert, E-Mail nicht gesendet",
invitationCreatedBody: "Wir haben die Einladung für {{email}} gespeichert, konnten sie aber nicht per E-Mail senden. Tippen Sie auf Erneut senden, um es noch einmal zu versuchen.",
failedToCreateInvite: "Einladung konnte nicht erstellt werden. Versuchen Sie es gleich noch einmal.",
archiveContactTitle: "Kontakt archivieren",
archiveContactBody: "Dieser Kontakt wird aus Listen ausgeblendet. Bei Bedarf können Sie ihn später wiederherstellen.",
failedToArchive: "Kontakt konnte nicht archiviert werden. Versuchen Sie es gleich noch einmal.",
invitesEmailResent: "Gesendet",
invitesEmailResentBody: "Einladungs-E-Mail erneut gesendet.",
inviteLinkUpdatedTitle: "E-Mail nicht gesendet",
inviteLinkUpdatedBody: "Die Einladung konnte nicht per E-Mail gesendet werden. Tippen Sie gleich noch einmal auf Erneut senden.",
timelineLoadingTitle: "Kontaktaktivität wird geladen",
timelineErrorTitle: "Aktivität ist unvollständig",
timelineEmptyTitle: "Noch keine Aktivität",
timelineLoadingSubtitle: "Verknüpfte Arbeit und Verlauf abrufen.",
timelineErrorSubtitle: "Einige verknüpfte Datensätze konnten nicht geladen werden. Versuchen Sie es erneut mit der oben verlinkten Arbeit.",
timelineEmptySubtitle: "Freigaben, Anfragen, Inspektionen, Arbeitsaufträge und Einladungen, die {{name}} betreffen, werden hier angezeigt.",
accessLevel: {
view: "Ansehen",
edit: "Bearbeiten",
manage: "Verwalten",
},
},
edit: {
pageTitle: "Kontakt bearbeiten",
noContactId: "Keine Kontakt-ID",
contactNotFound: "Kontakt nicht gefunden",
back: "Zurück",
kindA11yPerson: "Kontakttyp: Person",
kindA11yOrganisation: "Kontakttyp: Organisation",
basicIdentityHelperWide: "Person oder Organisation. Der Anzeigename (oder Vor- und Nachname) ist erforderlich.",
displayNameLabel: "Anzeigename *",
displayNamePlaceholder: "Name wird in Listen angezeigt",
displayNameA11yWide: "Anzeigename, erforderlich",
displayNameA11yNarrow: "Anzeigename (erforderlich)",
firstNameLabel: "Vorname",
firstNamePlaceholder: "Vorname",
lastNameLabel: "Nachname",
lastNamePlaceholder: "Nachname",
organisationsLabel: "Organisationen",
contactInfoHelper: "Wird für Einladungen und Nachfassaktionen verwendet.",
emailLabel: "E-Mail",
emailPlaceholder: "email@example.com",
emailA11yWide: "E-Mail-Adresse",
phoneLabel: "Telefon",
whoIsThisHelperNarrow: "Person oder Organisation. Name ist erforderlich; Organisation hilft beim Kontext.",
contactMethodHelperNarrow: "E-Mail oder Telefon hilft Ihnen, sie später zu erreichen.",
rolesTitleWide: "Rollen und Typen",
rolesTitleNarrow: "Welche Rolle spielt dieser Kontakt für uns?",
rolesHelper: "Wählen Sie eine oder mehrere Rollen aus, damit dieser Kontakt in den richtigen Flows angezeigt wird.",
visibilityHelperWide: "Nur mein Team: Nur Ihr Team sieht diesen Kontakt. Alle in meinem Unternehmen: Alle Teams sehen ihn.",
visibilityTitleNarrow: "Wer kann diesen Kontakt nutzen?",
visibilityHelperNarrow: "Nur Ihr Team sieht ihn, außer Sie wählen Alle in meinem Unternehmen. Sie können ihn später mit allen Teams teilen.",
visibilityA11yTeam: "Sichtbarkeit: nur mein Team",
visibilityA11yAccount: "Sichtbarkeit: alle in meinem Unternehmen",
vatA11y: "Umsatzsteuer- oder Steuernummer",
notesTitleWide: "Notizen",
notesTitleNarrow: "Optionale Details",
notesHelper: "Notizen sind für Ihr Team privat.",
improving: "Wird verbessert...",
improveWithAi: "Mit KI verbessern",
addNotesFirstTitle: "Zuerst Notizen hinzufügen",
addNotesFirstBody: "Geben oder diktieren Sie einen kurzen Entwurf und verwenden Sie dann „Mit KI verbessern“.",
unableToImproveNotesTitle: "Notizen können nicht verbessert werden",
improveNotesFailed: "Die Notizen konnten nicht verbessert werden. Bitte versuchen Sie es erneut.",
tidiedNotesTitle: "Aufgeräumte Notizen",
tidiedNotesRationale: "Überprüfen Sie die aufgeräumten Notizen, bevor Sie sie übernehmen.",
saveChanges: "Änderungen speichern",
saving: "Wird gespeichert…",
requiredTitle: "Erforderlich",
requiredNameBody: "Geben Sie einen Namen ein: Anzeigename oder Vor- und Nachname oder Organisationsname.",
workspaceChangedError: "Ihr Arbeitsbereich hat sich geändert. Öffnen Sie den Kontakt erneut, bevor Sie fortfahren.",
updateFailed: "Ihre Änderungen konnten nicht gespeichert werden. Versuchen Sie es gleich noch einmal.",
},
import: {
  actions: {
    addManually: "Manuell hinzufügen",
    phonePicker: "Telefonauswahl",
    uploadFile: "Datei hochladen",
  },
  access: {
    whyLine: "AssetWRX liest Ihre Kontakte nur, damit Sie auswählen können, wen Sie hinzufügen.",
    deniedTitle: "Kontaktzugriff ist aus",
    deniedBody: "Erlauben Sie den Zugriff, um die Kontakte Ihres Telefons hier zu sehen. Sie können Personen weiterhin manuell oder über die Telefonauswahl hinzufügen.",
    allow: "Zugriff erlauben",
    openSettings: "Einstellungen öffnen",
    limited: "Sie haben AssetWRX nur einige Kontakte freigegeben. Nutzen Sie die Telefonauswahl für alle anderen.",
    unavailableTitle: "Die Kontakte Ihres Telefons sind hier nicht verfügbar",
    unavailableBody: "Der Import aus Kontakten funktioniert in der iOS- und Android-App. Hier können Sie Personen manuell hinzufügen oder eine Datei hochladen.",
  },
  list: {
    searchA11y: "Kontakte suchen",
    searchPlaceholder: "Name, Firma, E-Mail oder Telefon suchen",
    count_one: "{{count}} Kontakt auf diesem Telefon",
    count_other: "{{count}} Kontakte auf diesem Telefon",
    loading: "Ihre Kontakte werden geladen…",
    emptyTitle: "Keine Kontakte auf diesem Telefon",
    emptyBody: "Fügen Sie Personen manuell hinzu oder nutzen Sie die Telefonauswahl, wenn Ihre Kontakte in einer anderen App liegen.",
    noMatchTitle: "Niemand passt zu „{{query}}“",
    noMatchBody: "Prüfen Sie die Schreibweise oder suchen Sie nach Firma, E-Mail oder Telefon.",
    alreadyAdded: "Bereits in AssetWRX",
    reviewA11y: "{{name}} vor dem Hinzufügen prüfen",
    selectA11y: "{{name}} auswählen",
    selectAll: "Alle auswählen ({{total}})",
    clearSelection: "Auswahl aufheben",
    import: "Importieren",
    importCount_one: "{{count}} importieren",
    importCount_other: "{{count}} importieren",
  },
  confirm: {
    title_one: "{{count}} Kontakt hinzufügen",
    title_other: "{{count}} Kontakte hinzufügen",
    subtitle: "Aus den Kontakten Ihres Telefons",
    alreadyNote_one: "{{count}} davon ist bereits in AssetWRX und wird erneut hinzugefügt.",
    alreadyNote_other: "{{count}} davon sind bereits in AssetWRX und werden erneut hinzugefügt.",
    roleLabel: "Rolle",
    roleHelper: "Optional. Gilt für alle, die Sie hinzufügen, und lässt sich später ändern.",
    visibilityLabel: "Wer sie sehen kann",
    privacy: "Fügen Sie nur Personen hinzu, mit denen Sie arbeiten. Sie sind sichtbar für {{audience}}.",
    audienceTeam: "Ihr Team",
    audienceAccount: "alle in Ihrem Unternehmen",
    cancel: "Abbrechen",
    confirm_one: "{{count}} hinzufügen",
    confirm_other: "{{count}} hinzufügen",
    progress: "{{done}} von {{total}} wird hinzugefügt…",
    closeA11y: "Schließen",
  },
  notes: {
    jobTitle: "Position: {{value}}",
    otherEmails: "Weitere E-Mails: {{value}}",
  },
  alerts: {
    readFailedTitle: "Kontakte konnten nicht gelesen werden",
    readFailedDefaultBody: "Versuchen Sie es erneut oder fügen Sie Personen einzeln über die Telefonauswahl hinzu.",
    pickerFailedTitle: "Die Kontaktauswahl konnte nicht geöffnet werden",
    pickerFailedDefaultBody: "Erlauben Sie in den Einstellungen den Zugriff auf Kontakte und versuchen Sie es erneut.",
    invalidContactTitle: "Ungültiger Kontakt",
    invalidContactBody: "Dieser Kontakt hat keine verwertbaren Informationen. Bitte wählen Sie einen anderen aus.",
    noAccountTitle: "Kein Konto",
    noAccountBody: "Sie müssen sich in einem Konto befinden, um Kontakte hinzuzufügen.",
    stoppedTitle: "Import gestoppt",
    stoppedWithProgress: "{{count}} vor einem Fehler hinzugefügt: {{error}}",
    unknownError: "Unbekannter Fehler",
    completeBody_one: "{{count}} Kontakt hinzugefügt.",
    completeBody_other: "{{count}} Kontakte hinzugefügt.",
  },
  review: {
    requiredTitle: "Erforderlich",
    requiredBody: "Geben Sie einen Namen ein.",
    errorTitle: "Fehler",
    errorDefaultBody: "Fehler beim Erstellen des Kontakts.",
    noContactSelected: "Kein Kontakt ausgewählt. Gehen Sie zurück und wählen Sie einen von Ihrem Telefon aus.",
    backToContacts: "Zurück zu den Kontakten",
    nameSectionTitle: "Name *",
    nameA11y: "Name (erforderlich)",
    namePlaceholder: "Anzeigename",
    companyA11y: "Firma (optional)",
    companyPlaceholder: "Firma (optional)",
    notesA11y: "Notizen (optional)",
    notesPlaceholder: "Private Notizen (optional)",
    visibilitySectionTitle: "Wer kann diesen Kontakt nutzen?",
    skillsSectionTitle: "Fähigkeiten",
    skillsPickerHint: "Optional: Fügen Sie diesem importierten Kontakt Fähigkeiten aus dem Katalog hinzu.",
    nameLabel: "Name",
    companyLabel: "Firma",
    notesLabel: "Notizen",
    rolesSectionTitle: "Rolle",
    moreDetails: "Weitere Angaben",
    fewerDetails: "Weniger Angaben",
    extraPhones_one: "Fügt außerdem {{count}} weitere Nummer hinzu: {{numbers}}",
    extraPhones_other: "Fügt außerdem {{count}} weitere Nummern hinzu: {{numbers}}",
    existingTitle: "Bereits in AssetWRX als {{name}}",
    existingOpen: "Öffnen",
    save: "Speichern",
    saveAndAnother: "Speichern und weiteren hinzufügen",
    addedToast: "{{name}} hinzugefügt",
  },
},
picker: {
  createNamed: "„{{search}}“ anlegen",
defaultTitle: "Kontakt auswählen",
closeA11y: "Kontaktauswahl schließen",
searchPlaceholder: "Suchen Sie nach Name, Unternehmen, E-Mail oder Rolle ...",
searchA11y: "Kontakte suchen",
scope: {
all: "Alle",
team: "Nur Team",
account: "Ganzer Arbeitsbereich",
},
sections: {
recommended: "Empfohlen für diese Arbeit",
recent: "Kürzlich",
searchResults: "Suchergebnisse",
allContacts: "Alle Kontakte",
},
searching: "Suche...",
empty: {
  noMatch: "Noch niemand namens „{{search}}“.",
  noneNoCreate: "Noch keine Kontakte.",
  none: "Noch keine Kontakte. Tippen Sie auf {{label}}.",
skillsScoped: "Keine {{scope}}-Kontakte entsprechen diesen Fähigkeiten. Alle Kontakte anzeigen oder einen Skill-Filter deaktivieren.",
searchScoped: "Keine {{scope}}-Kontakte entsprechen Ihrer Suche. Alle Kontakte anzeigen oder einen anderen Namen ausprobieren.",
idleScoped: "Noch keine Kontakte für {{scope}} freigegeben. Zeigen Sie alle Kontakte an oder fügen Sie einen hinzu.",
skills: "Kein Kontakt entspricht diesen Fähigkeiten. Deaktivieren Sie einen Skill-Filter oder suchen Sie nach Namen.",
search: "Keine passenden Kontakte.",
idle: "Geben Sie ein, um nach Kontakten zu suchen.",
},
showAllContacts: "Alle Kontakte anzeigen",
clearScopeA11y: "Löschen Sie den {{scope}}-Filter und zeigen Sie alle Kontakte an",
deselectA11y: "Auswahl von {{name}} aufheben",
selectA11y: "Wählen Sie {{name}}",
selectWithRolesA11y: "Wählen Sie {{name}}, Rollen {{roles}}",
recommendedReason: "Empfohlen · {{reason}}",
workspaceWide: "Ganzes Unternehmen",
teamOnly: "Nur mein Team",
skillsLabel: "Fähigkeiten",
clear: "Zurücksetzen",
clearSkillFiltersA11y: "Fertigkeitsfilter löschen",
addFilter: "Filter hinzufügen",
hide: "Ausblenden",
hideSkillListA11y: "Fertigkeitsfilterliste ausblenden",
addSkillFiltersA11y: "Fertigkeitsfilter hinzufügen",
skillFilterHint: "Optional: Kontakte nach einer oder mehreren Fähigkeiten filtern.",
removeSkillFilterA11y: "{{skill}}-Filter entfernen",
fromThisJob: "Aus diesem Arbeitsauftrag",
filterBySkillA11y: "Filter nach {{skill}}",
searchSkillsPlaceholder: "Fähigkeiten suchen...",
searchSkillsA11y: "Fähigkeiten suchen",
noSkillsMatch: "Keine Fähigkeiten entsprechen Ihrer Suche.",
addAction: "Hinzufügen",
removeAction: "Entfernen",
toggleSkillFilterA11y: "{{action}} {{skill}} Filter",
selectedCount_one: "{{count}} ausgewählt",
selectedCount_other: "{{count}} ausgewählt",
continueLabel: "Weiter",
continueWithA11y: "Weiter mit {{count}} {{noun}}",
contactNoun_one: "Kontakt",
contactNoun_other: "Kontakte",
},
organisationsField: {
empty: "Noch keine Organisationen verlinkt.",
chooseOrganisation: "Organisation auswählen",
primaryA11y: "Primäre Organisation",
removeA11y: "Organisation entfernen",
titlePlaceholder: "Titel (z. B. Zuverlässigkeitsleiter)",
titleA11y: "Titel bei der Organisation",
addA11y: "Organisation hinzufügen",
addLabel: "Organisation hinzufügen",
pickerTitle: "Organisation auswählen",
},
phonesField: {
empty: "Noch keine Telefonnummern.",
phoneTypeA11y: "Telefontyp {{label}}",
primaryA11y: "Primäres Telefon",
removeA11y: "Telefon entfernen",
addA11y: "Telefonnummer hinzufügen",
addLabel: "Telefon hinzufügen",
},
threeSixty: {
assetSharedTitle: "{{asset}} mit {{name}} geteilt",
shareSubtitle: "Teilen · {{status}}",
requestSubtitle: "Anfrage · {{status}}",
jobFallback: "Auftrag",
inspectionLabel: "Inspektion",
contactJoinedTitle: "{{name}} ist der App beigetreten",
invitedTitle: "Zur App eingeladen ({{email}})",
invitationSubtitle: "Einladung · {{status}}",
appStandingInApp: "In der App",
appStandingPending: "Einladung ausstehend seit {{when}}",
appStandingNotInvited: "Noch nicht eingeladen",
statusActive: "Aktiv",
lastActivity: "Letzte Aktivität {{when}}",
noActivityYet: "Noch keine Aktivität",
noEmailOrPhone: "Keine E-Mail oder Telefonnummer hinterlegt.",
emailA11y: "E-Mail {{email}}",
callA11y: "{{phone}} anrufen",
openWork: {
sharedAssets: "Gemeinsame Anlagen",
openRequests: "Offene Anfragen",
openInspections: "Offene Prüfungen",
openJobs: "Offene Aufträge",
},
openWorkInfo: {
sharedAssetsDesc: "Anlagen, die dieser Kontakt sehen und für die er über eine aktive Freigabe Anfragen stellen kann.",
sharedAssetsBasedOn: "{{active}} von {{total}} Freigaben noch aktiv, live gezählt",
openRequestsDesc: "Anfragen von oder für diesen Kontakt, die nicht geschlossen, abgelehnt oder umgewandelt wurden.",
openRequestsBasedOn: "{{open}} von {{total}} Anfragen noch offen, live gezählt",
openInspectionsDesc: "Mit diesem Kontakt verknüpfte Inspektionen, die noch nicht abgeschlossen wurden.",
openInspectionsBasedOn: "{{open}} von {{total}} verknüpfte Inspektionen, live gezählt",
openJobsDesc: "Unvollendete Arbeitsaufträge, die explizit mit diesem Kontakt verknüpft sind. Arbeiten, die nur über ihr Benutzerkonto zugewiesen wurden, werden hier möglicherweise nicht angezeigt.",
openJobsBasedOn: "{{open}} von {{total}} verknüpften Aufträgen, live gezählt",
},
loadingLinkedWork: "Verknüpfte Arbeit wird geladen",
linkedWorkErrorTitle: "Verlinkte Arbeit konnte nicht geladen werden",
openWithName: "Offene Arbeit mit {{name}}",
noOpenWork: "{{name}} hat keine offene Arbeit. Um einen Auftrag zu vergeben, öffnen Sie ihn und tippen Sie auf Zuweisen.",
},
operational: {
tabsLabel: "Kontaktbereiche",
tabs: {
overview: "Übersicht",
assets: "Anlagen",
requests: "Anfragen",
history: "Verlauf",
},
sharedAssetsTitle: "Geteilte Anlagen",
sharedAssetsEmpty: "Noch keine Anlagen geteilt. Geben Sie eine Anlage frei, damit dieser Kontakt Inspektionen anfordern oder Arbeitsaufträge vorschlagen kann.",
requestsTitle: "Anfragen",
requestsEmpty: "Bisher keine Anfragen von diesem Kontakt.",
relatedWorkTitle: "Verwandte Arbeiten",
relatedWorkEmpty: "Noch keine entsprechenden Arbeitsaufträge oder Inspektionen.",
notesTitle: "Notizen",
notesEmpty: "Keine Notizen zu diesem Kontakt.",
assetLinksTitle: "Anlagenlinks",
assetLinksHelper: "Links auf Datensatzebene (nicht dasselbe wie Arbeitsbereichsfreigabe).",
assetFallback: "Anlage",
jobFallback: "Auftrag",
workspaceAccess: "Zugriff auf den Arbeitsbereich",
permissionJobs: "Aufträge",
permissionInspections: "Inspektionen",
permissionDocuments: "Dokumente",
scheduleProposedAndScheduled: "Vorgeschlagen {{proposed}} · Geplant {{scheduled}}",
scheduleScheduled: "Geplant {{scheduled}}",
scheduleProposed: "Vorgeschlagen {{proposed}}",
statusPrefix: "Status {{status}}",
openRequestCount_one: "{{count}} offene Anfrage",
openRequestCount_other: "{{count}} offene Anfragen",
openAssetA11y: "Öffnen Sie die Anlage {{name}}",
requestA11y: "Anfrage {{title}}",
jobA11y: "Arbeitsauftrag {{label}}",
inspectionA11y: "Inspektion {{title}}",
shareAsset: "Anlage teilen",
shareAssetA11y: "Wählen Sie eine Anlage zum Teilen aus",
allRequests: "Alle Anfragen",
allRequestsA11y: "Alle Anfragen anzeigen",
email: "E-Mail",
emailA11y: "E-Mail an Kontakt senden",
invite: "Einladen",
inApp: "In der App",
inviteA11y: "Kontakt einladen",
shareContact: "Kontakt teilen",
shareContactA11y: "Kontakt mit dem Team teilen",
},
linkCard: {
unlinkA11y: "Kontakt trennen",
otherRole: "Sonstiges",
contactFallback: "Kontakt",
},
inviteLanding: {
  acceptFailed: "Die Einladung konnte nicht angenommen werden. Versuchen Sie es erneut oder bitten Sie die Person, die sie gesendet hat, um eine neue.",
  acceptFailedTitle: "Einladung konnte nicht angenommen werden",
  accepted: "Geschafft. Alles, was mit Ihnen geteilt wird, finden Sie auf der Startseite.",
  expired: "Diese Einladung ist abgelaufen. Bitten Sie die Person, die sie gesendet hat, um eine neue.",
  desc: "{{name}}, Sie wurden zu AssetWRX eingeladen. Melden Sie sich an, um zu sehen, was mit Ihnen geteilt wurde.",
},
};